import { defineStore } from "pinia";
import { computed, ref } from "vue";
import type { Organization } from "@/api/users.ts";
import api from "@/api/axios.ts";
import { useStorage } from "@vueuse/core";

export const useProfileStore = defineStore("profile", () => {
  const organizations = ref<Organization[]>([]);
  const selectedOrganizationId = useStorage("selectedOrganizationId", 0);
  async function initialize() {
    const responseOrgs = await api.get("/custom/gastrofresh/profile/organizations");
    console.log("responseOrgs", responseOrgs.data);
    organizations.value = responseOrgs.data.rows;
    if (responseOrgs.data.rows.length > 0 && !selectedOrganizationId.value) {
      // automatically select the first organization if none is selected
      selectedOrganizationId.value = responseOrgs.data.rows[0].id;
    } else if (
      selectedOrganizationId.value &&
      !responseOrgs.data.rows.find((org: Organization) => org.id === selectedOrganizationId.value)
    ) {
      // previously selected organization is no longer available, select the first one
      selectedOrganizationId.value = responseOrgs.data.rows[0].id;
    }
    console.log("Selected organization ID:", selectedOrganizationId.value);
  }

  const selectOrganizationId = (organizationId: number) => {
    selectedOrganizationId.value = organizationId;
  };

  const selectedOrganizationPortalDiscount = computed(() => {
    const org = organizations.value.find((org) => org.id === selectedOrganizationId.value);
    return org ? org.portalDiscountPct : 0;
  });

  return {
    initialize,
    organizations,
    selectedOrganizationId,
    selectOrganizationId,
    selectedOrganizationPortalDiscount,
  };
});
